import React, { useState } from "react";
import { useDrop } from "react-dnd";
import { observer } from "mobx-react";

interface Props {
  time: string;
  currentDate:string;
  children: React.ReactNode;
  onDropEvent: (toTime: string, data:any, currentDate:any) => void;
  onClick?: () => void;
}

const OuterDroppableCell: React.FC<Props> = ({
  time,
  currentDate,
  children,
  onDropEvent,
}) => {
  const [{ isOver }, drop] = useDrop(() => ({
    accept: "EVENT",
    drop: (item: { data: any; currentDate:any }) => {
      onDropEvent(time, item.data, currentDate);
    },
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  }));

  return (
    <div
      ref={drop}
      className={`minute-cell-dropdown dropdown position-relative ${
        isOver ? "highlight" : ""
      }`}
    >
      {children}
    </div>
  );
};

export default observer(OuterDroppableCell);
